<template>
    <div id="root" class="mobileRoot">
        <div v-show="loadHome" id="home" class="mobileHome">
            <div id="mobile-home-outer-wrapper" class="mobileHomeOuterWrapper">
                <div id="mobile-home-header" class="mobileHomeHeader">
                    <div
                        id="mobile-home-search-wrapper"
                        class="mobileHomeSearchWrapper"
                    >
                        <div id="mobile-home-logo" class="mobileHomeLogo">
                            <img
                                id="mobile-home-logo-img"
                                class="mobileHomeLogoImage"
                                :src="branding.logo"
                            />
                        </div>
                        <div
                            id="mobile-home-input-wrapper"
                            class="mobileHomeInputWrapper"
                        >
                            <!--<input id="mobile-home-input" class="mobileHomeInput" v-model="query" :placeholder="`${currentMode.name} Search`" @keydown.enter="goToSerp()">-->
                            <auto-complete-input
                                v-model="query"
                                ref="queryInput"
                                id="mobile-home-input"
                                class="mobileHomeInput"
                                :group="currentGroupNumber || -1"
                                :placeholder="branding.AutocompletePlaceholder"
                                @selected="goToSerp()"
                                @return="goToSerp()"
                                @iconClick="goToSerp()"
                            />
                        </div>
                        <div
                            id="mobile-home-header-navigation"
                            class="mobileHomeHeaderNavigation"
                        >
                            <div
                                v-for="(navItem, index) in viewList"
                                :key="index"
                                :id="`nav_${navItem.name}`"
                                class="mobileNavItem"
                                :class="{
                                    activeNavItem:
                                        currentMode.name == navItem.name,
                                }"
                                @click="changeMode(navItem)"
                            >
                                <img
                                    :id="`nav-icon_${navItem.name}`"
                                    class="mobileNavIcon"
                                    :src="navItem.icon"
                                />
                                <div
                                    :id="`nav-title_${navItem.name}`"
                                    class="mobileNavTitle"
                                >
                                    {{ navItem.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="
                        activeStoryBlockList && activeStoryBlockList.length > 0
                    "
                    id="mobile-home-body"
                    class="mobileHomeBody"
                >
                    <div class="mobile-home-body-left">
                        <div id="mobile-hero-wrapper" class="mobileheroWrapper">
                            <hero-block
                                v-if="
                                    heroStory &&
                                        heroStory.story &&
                                        heroStory.category
                                "
                                :story="heroStory.story"
                                :category="heroStory.category"
                            ></hero-block>
                        </div>

                        <div id="news-wrapper" class="newsWrapper">
                            <div
                                v-if="
                                    activeStoryBlockList &&
                                        activeStoryBlockList.length > 0
                                "
                                id="news-block-inner-wrapper"
                                class="newsBlockInnerWrapper"
                                :key="newsKey"
                            >
                                <div
                                    v-for="(storyList,
                                    index) in activeStoryBlockList"
                                    :key="index"
                                    id="news-block"
                                    class="newsBlock"
                                >
                                    <story-block
                                        :category="storyList.name"
                                        :storyList="storyList.storyList"
                                        :fullStoryMode="fullStoryMode"
                                    ></story-block>
                                    <!-- only load ads on initial block and not other ones loaded later -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="mobileHomeFooter" class="mobileHomeFooter">
                    <freshy-footer />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from "query-string";
import { mobileVerticalList, defaultVertical } from "@/linkLists";
import { YAHOO_COBRAND_URL } from "@/urls";
import FreshyFooter from "@/components/footer/Footer.vue";
import AutoCompleteInput from "@/components/autoCompleteInput/MobileAutoCompleteInput.vue";
import { pageviewEvent, searchEvent, clickEvent } from "@/analytics";
import { getBranding } from "@/branding";
import { documentReady } from "@/common";
import home from "../common/mixins/home";
import HeroBlock from "../common/components/heroBlockMobile";
// import WeatherBlock from "../common/components/weatherBlock";
import StoryBlock from "../common/components/storyBlockMobile";

export default {
    mixins: [home],
    components: {
        "freshy-footer": FreshyFooter,
        "auto-complete-input": AutoCompleteInput,
        "story-block": StoryBlock,
        // "weather-block": WeatherBlock,
        "hero-block": HeroBlock,
    },
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            currentMode: defaultVertical,
            searchParams: qs || null,
            query: qs.q || null,
            typeTag: qs.type || null,
            guid: qs.guid || null,
            viewList: mobileVerticalList,
            branding: getBranding(),
            fullStoryMode: true,
            activeStoryCategories: [],
            newsKey: 0,
            heroStory: null,
            loadHome: false,
        };
    },
    mounted() {
        this.activeBlockStoryCount = 1;
        this.activeBlockAddSize = 5;

        if (this.query) {
            const queryParams = this.getQueryParameters();
            if (queryParams && queryParams.q) {
                const newUrl = `/web?${queryString.stringify(queryParams)}`;
                window.open(
                    newUrl,
                    window.self !== window.top ? "_parent" : "_self"
                );
                return;
            }
        }
        this.loadHome = true;

        document.title = "Freshy";
        document.querySelector("#mobile-home-input").focus();
        pageviewEvent(null, null, this.typeTag);
        const feedPromise = this.getAllFeeds();

        documentReady.then(async () => {
            document.querySelector("#auto-complete-input").focus();

            // redirect if q parameter is present
            if (this.searchParams && this.searchParams.q) {
                window.location.href = `/web?${queryString.stringify(
                    this.searchParams
                )}&type=xml`;
            }

            await feedPromise;
            this.initNewsFeeds();
            await this.addStories(false);
            this.heroStory = this.getHeroStory();
        });
    },
    computed: {
        currentGroupNumber() {
            return this.currentMode.group;
        },
        topStories() {
            if (this.newsFeeds && this.newsFeeds["top news"])
                return this.newsFeeds["top news"].splice(0, 5);
            return null;
        },
        filteredNewsFeeds() {
            if (
                this.newsFeeds &&
                (!this.activeStoryCategories ||
                    this.activeStoryCategories.length == 0)
            )
                return this.newsFeeds;
            if (
                this.newsFeeds &&
                this.activeStoryCategories &&
                this.activeStoryCategories.length > 0
            ) {
                const feeds = {};
                for (const i in this.activeStoryCategories)
                    if (this.newsFeeds[this.activeStoryCategories[i]]) {
                        feeds[this.activeStoryCategories[i]] = this.newsFeeds[
                            this.activeStoryCategories[i]
                        ];
                    }
                return feeds;
            }
            return null;
        },
    },
    watch: {
        async activeStoryCategories() {
            document.querySelector("#root").scrollTo(0, 0);
            this.activeStoryBlockList = [];
            this.storyBlockList = [];
            this.activeBlockStart = 0;

            if (this.activeStoryCategories.length == 0) {
                this.fullStoryMode = false;
                this.activeBlockStoryCount = 7;
                this.activeBlockAddSize = 3;
            } else {
                this.fullStoryMode = true;
                this.activeBlockStoryCount = 3;
                this.activeBlockAddSize = 5;
            }
            await this.addStories(false);
            this.newsKey++;
        },
    },
    methods: {
        async addStories(shuffle = true, secondRun = false) {
            if (this.filteredNewsFeeds && this.filteredNewsFeeds != {}) {
                const currentLength = this.storyBlockList.length;
                if (
                    this.storyBlockList &&
                    currentLength > 0 &&
                    this.activeBlockStart + this.activeBlockAddSize <
                        currentLength
                ) {
                    const newList = this.storyBlockList.slice(
                        this.activeBlockStart,
                        this.activeBlockStart + this.activeBlockAddSize
                    );
                    this.activeStoryBlockList = this.activeStoryBlockList.concat(
                        newList
                    );
                    this.activeBlockStart += this.activeBlockAddSize;
                } else if (!secondRun) {
                    this.addToBlockList(shuffle);
                    await this.addStories(true, true);
                }
            }
        },
        changeMode(mode) {
            this.currentMode = mode;
            clickEvent(
                null,
                `Home Page Vertical Click`,
                this.currentMode.name,
                this.typeTag
            );
        },
        getQueryParameters() {
            const out = {};
            if (this.query) out.q = this.query;
            if (this.typeTag) out.type = this.typeTag;
            if (this.guid) out.guid = this.guid;

            return out;
        },
        goToSerp() {
            if (this.query && this.currentMode.path) {
                let newUrl = `${this.currentMode.path}`;
                const queryParams = this.getQueryParameters();
                if (queryParams)
                    newUrl += `?${queryString.stringify(queryParams)}`;

                window.open(
                    newUrl,
                    window.self !== window.top ? "_parent" : "_self"
                );
            }
        },
        addScrollListener() {
            const root = document.querySelector("#root");

            const scrollEv = () => {
                // OFFSET TO TRIGGER, HAVE SET TO OFFSET HEIGHT
                const OFFSET = root.offsetHeight;

                if (
                    root.scrollTop >=
                    root.scrollHeight - (root.offsetHeight + OFFSET)
                ) {
                    this.addStories();
                } else if (
                    root.scrollTop >=
                    root.scrollHeight - (root.offsetHeight + OFFSET / 2)
                ) {
                }
            };

            try {
                root.removeEventListener("scroll", scrollEv);
            } catch (e) {
                console.error("ERROR SCROLL: ", e);
            }
            // Add load on scroll

            root.addEventListener("scroll", scrollEv);
        },
        initNewsFeeds() {
            if (this.newsFeeds) {
                this.addToBlockList();
                this.addScrollListener();
            }
        },
    },
};
</script>
<style scoped src="./mobilehome.css"></style>
